export default {"src":"/_next/static/media/business11.8e59198f.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};